/**
 * 订阅成功弹窗的行为（配 snippets/soulog-subscribe-success-modal.liquid，全站单例）。
 *
 * 两段：
 *   1. 提交任意 .signup-form 时，把邮箱记进 sessionStorage —— 订阅是整页 POST 后重定向，
 *      回跳那一刻 Liquid 既分不清是哪个表单提交的、也拿不到用户填的邮箱（form.email
 *      在成功态是空的），只能靠提交瞬间的 JS 把它带过跳转。
 *   2. 页面加载时结算：URL 带 customer_posted（Shopify 只在订阅成功后才这么重定向）
 *      且本人确实提交过，两个条件同时成立才弹。凭据用完即删，于是手动刷新成功页、
 *      或直接打开一条别人发来的带 customer_posted 的链接都不会再弹。
 *
 * 注意：邮箱是用户输入，只能 textContent 写进去，不要拼 innerHTML。
 */
(function () {
	var PENDING_KEY = "soulogSubscribePendingEmail";
	var ROOT_ID = "SubscribeSuccessModal";
	var OPEN_CLASS = "is-open";
	var CLOSE_MS = 300;

	function readPending() {
		try {
			return window.sessionStorage.getItem(PENDING_KEY);
		} catch (e) {
			return null;
		}
	}

	function writePending(value) {
		try {
			window.sessionStorage.setItem(PENDING_KEY, value);
		} catch (e) {}
	}

	function clearPending() {
		try {
			window.sessionStorage.removeItem(PENDING_KEY);
		} catch (e) {}
	}

	/* 邮箱可能取不到（表单结构被改过），此时仍写空串 —— 这条记录同时是「这次跳转是本人提交
	   触发的」的凭据，缺了它回跳就不弹了；文案退回不含邮箱的那句即可。 */
	document.addEventListener(
		"submit",
		function (event) {
			var form = event.target;
			if (!form || !form.classList || !form.classList.contains("signup-form")) return;
			var input = form.querySelector('input[type="email"]');
			writePending(input && input.value ? String(input.value).trim() : "");
		},
		true,
	);

	/* 只认 customer_posted 这个 key，值是什么不重要（Shopify 给的是 true）。
	   用正则而不是 URLSearchParams：少一个依赖，也好在测试里跑。 */
	function isPostedBack() {
		var search = (window.location && window.location.search) || "";
		return /[?&]customer_posted=/.test(search);
	}

	function close(root) {
		root.classList.remove(OPEN_CLASS);
		document.body.classList.remove("overflow-hidden");
		// 等淡出过渡跑完再 hidden，否则会直接消失
		window.setTimeout(function () {
			root.setAttribute("hidden", "hidden");
		}, CLOSE_MS);
	}

	function bindClose(root) {
		root.addEventListener("click", function (event) {
			// 点遮罩（卡片以外的区域）或任一 data-close 按钮都关
			if (event.target === root || (event.target.closest && event.target.closest("[data-close]"))) {
				close(root);
			}
		});
		document.addEventListener("keydown", function (event) {
			if (root.hasAttribute("hidden")) return;
			var key = event.key || "";
			if (key === "Escape" || key === "Esc") {
				close(root);
				return;
			}
			// 焦点圈在弹窗内（就两个按钮），别让 Tab 跑到背后的页面上去
			if (key !== "Tab") return;
			var focusables = root.querySelectorAll("button");
			if (!focusables.length) return;
			var first = focusables[0];
			var last = focusables[focusables.length - 1];
			if (event.shiftKey && document.activeElement === first) {
				event.preventDefault();
				last.focus();
			} else if (!event.shiftKey && document.activeElement === last) {
				event.preventDefault();
				first.focus();
			}
		});
	}

	function open(root, email) {
		var slot = root.querySelector("[data-email]");
		var text = root.querySelector("[data-text]");
		if (email && slot) {
			slot.textContent = email;
		} else if (text) {
			// 没有邮箱就整句换成不含邮箱的版本，避免「updates to  and let you know」这种空洞
			text.textContent = text.getAttribute("data-generic") || "";
		}
		bindClose(root);
		root.removeAttribute("hidden");
		// 强制回流，让紧接着加的 is-open 真的触发过渡而不是瞬间到位
		void root.offsetHeight;
		root.classList.add(OPEN_CLASS);
		document.body.classList.add("overflow-hidden");
		var dismiss = root.querySelector("[data-dismiss]");
		if (dismiss && dismiss.focus) dismiss.focus();
	}

	function init() {
		var root = document.getElementById(ROOT_ID);
		if (!root) return;
		var pending = readPending();
		if (!isPostedBack()) {
			/* 没回跳成功页却留着凭据 = 上一次提交被服务端挡下了（表单带 form.errors 原样返回，
			   URL 上没有 customer_posted）。就地清掉，免得它一直挂到下次访问某条带
			   customer_posted 的链接时错弹。 */
			if (pending !== null) clearPending();
			return;
		}
		if (pending === null) return;
		clearPending();
		open(root, pending);
	}

	// 本脚本是 defer 加载的，执行时 DOM 已就绪
	init();
})();
